

export default superclass => class extends superclass  {

    cachedTidal = {};

    getConnectedTidal(number=0, type, outlets=this.outlets) {
        if (this.cachedTidal[number]) {
            return this.cachedTidal[number];
        }
        let found = this.searchForNode("jaki", type, outlets);
        if (found) {
            this.cachedTidal[number] = found.effect.tidals[number];
        }
        return this.cachedTidal[number];
    }


}
